export default __webpack_public_path__ + "static/media/1134.3e23ebe5.png";